import React, { FunctionComponent } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { AppPath } from '../../../AppPath'
import { BeforeWeBeginPage, DisclosureRouter } from '../disclosure'
import { ProposalPath } from '../ProposalPath'

export const ProposalInsufficientAccuracyRoutes: FunctionComponent = () => (
  <Routes>
    <Route key='before-we-begin' index element={<BeforeWeBeginPage />} />
    <Route
      key='disclosure'
      path={ProposalPath.DISCLOSURE + AppPath.WILDCARD}
      element={<DisclosureRouter />}
    />
    <Route path='*' element={<Navigate to={AppPath.HOME} />} />
  </Routes>
)
